import { Component, Input } from '@angular/core';
import { DialogConfig } from 'src/app/modules/shared/components/alert-dialog/dialog-config';
import { ArchiveCatalog } from 'src/app/modules/shared/models/archive/archive-catalog.model';
import { ArchiveFileFormHeaderFindRequest } from 'src/app/modules/shared/models/archive/archive-file-form-header-find-request.model';
import { ArchiveFileFormHeaderInfo } from 'src/app/modules/shared/models/archive/archive-file-form-header-info.model';
import { FormHeaderHorizontalList } from 'src/app/modules/shared/models/form/form-header-horizontal.enum';
import { FormHeaderType } from 'src/app/modules/shared/models/form/form-header-type.enum';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { ArchiveFileFormHeaderService } from 'src/app/modules/shared/services/archive-file-form-header.service';

@Component({
  selector: 'app-dialog-archive-headers',
  templateUrl: './dialog-archive-headers.component.html',
  styleUrls: ['./dialog-archive-headers.component.scss'],
})
export class DialogArchiveHeadersComponent {
  @Input()
  data!: DialogConfig<ArchiveCatalog>;

  recordList: ArchiveFileFormHeaderInfo[] = [];
  recordList2: ArchiveFileFormHeaderInfo[] = [];

  id: number = -1;

  checkall = true;

  checkall2 = true;

  FormHeaderHorizontalList = FormHeaderHorizontalList;

  constructor(
    private archiveFileFormHeaderService: ArchiveFileFormHeaderService,
    private globalService: GlobalService
  ) {}

  ngOnInit() {
    this.archiveFileFormHeaderService
      .findOne<ArchiveFileFormHeaderFindRequest>({
        catalogId: this.data!.data!.id!,
      })
      .subscribe((res) => {
        console.log(res);
        this.id = res.id!;
        this.recordList = res.formHeaders!.filter(
          (item) => item.type === FormHeaderType.FIXED
        );
        this.recordList2 = res.formHeaders!.filter(
          (item) => item.type === FormHeaderType.FREE
        );
        this.onCheckChange();
      });
  }

  isNaN(content: number) {
    return window.isNaN(content);
  }

  cancel() {
    this.data.onCancel();
  }

  confirm() {
    this.submit();
  }

  get canConfirm() {
    return true;
  }

  onCheckAllChange() {
    for (const item of this.recordList) {
      item.selected = this.checkall;
    }
  }

  onCheckAll2Change() {
    for (const item of this.recordList2) {
      item.selected = this.checkall2;
    }
  }

  onCheckChange() {
    this.checkall = this.recordList.every((item) => item.selected);
    this.checkall2 = this.recordList2.every((item) => item.selected);
  }

  private submit() {
    this.archiveFileFormHeaderService
      .update({
        id: this.id!,
        formHeaders: [...this.recordList, ...this.recordList2],
      })
      .subscribe((response: boolean) => {
        if (response) {
          this.data.onConfirm!();
        }
      });
  }
}
